export const VIEW_OPTIONS = [
  { id: "breakdown", name: "Breakdown" },
  { id: "trend", name: "Trend" }
];
